import { URL_PRESENT_PAGE } from '@/constants/Url';

type OpenNewWebView = (url: string) => Promise<void> | void;

export const openPresentPage = async (openNewWebView: OpenNewWebView) => {
  await openNewWebView(URL_PRESENT_PAGE);
};
